import React from "react";

const ChemicalProducts = () => {
  return (
    <div>
      <section
        id="page-title"
        className="page-title page-title-layout10 bg-overlay bg-parallax text-center"
      >
        <div className="bg-img">
          <img src="../assets/images/page-titles/prfeed.jpg" alt="background" />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <h1 className="pagetitle__heading">Chemical Products</h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="/products">Products</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Chemical Products
                  </li>
                </ol>
              </nav>
            </div>
            {/* /.col-lg-12 */}
          </div>
          {/* /.row */}
        </div>
        {/* /.container */}
      </section>
      {/* /.page-title */}
      {/* ======================
        Text Content Section
      ========================= */}
      <section id="textContentSection" className="text-content-section">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-2" />
            <div className="col-sm-12 col-md-12 col-lg-8">
              <div className="text__block">
                <h5 className="text__block-title">Chemical Products</h5>
                <div>
                  <p>
                    We offer quotes and samples which include but are not
                    limited to the following:
                  </p>
                 
                  <div align="left">
                    <table className="table table-bordered">
                      <tbody>
                        <tr>
                          <td>
                            <p>Acetic Acid</p>
                          </td>
                          <td>
                            <p>Caustic Soda</p>
                          </td>
                          <td>
                            <p>Isopropyl Alcohol</p>
                          </td>
                          <td>
                            <p>Soda Ash (Light)</p>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>
                            <p>Ascorbic Acid</p>
                          </td>
                          <td>
                            <p>PAC R</p>
                          </td>
                          <td>
                            <p>Toluene</p>
                          </td>
                          <td>
                            <p>Soda Ash (Dense)</p>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>
                            <p>Butanol</p>
                          </td>
                          <td>
                            <p>XCD Polymer</p>
                          </td>
                          <td>
                            <p>White Oil</p>
                          </td>
                          <td>
                            <p>Formic Acid</p>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>
                            <p>Citric Acid</p>
                          </td>
                          <td>
                            <p>EDC 99</p>
                          </td>
                          <td>
                            <p>Mono Ethylene Glycol</p>
                          </td>
                          <td>
                            <p>Nitric Acid, HNO3</p>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>
                            <p>Ethyl Acetate</p>
                          </td>
                          <td>
                            <p>Sorbitol Liquid</p>
                          </td>
                          <td>
                            <p>Tri-Ethylene Glycol MonButyl Ether</p>
                          </td>
                          <td>
                            <p>Petroleum Jelly</p>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>
                            <p>Propanol</p>
                          </td>
                          <td>
                            <p>Pine Oil</p>
                          </td>
                          <td>
                            <p>Maleic Acid DL</p>
                          </td>
                          <td>
                            <p>Hydroxy Ethyl Cellulose (HEC 10 ) Powder</p>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>
                            <p>Calcium Chloride</p>
                          </td>
                          <td>
                            <p>Hydrochloric Acid</p>
                          </td>
                          <td>
                            <p>Urea</p>
                          </td>
                          <td>
                            <p>Hydroxy Ethyl Cellulose (HEC 10 ) Liquid</p>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>
                            <p>Potassium Chloride</p>
                          </td>
                          <td>
                            <p>Sulfuric Acid</p>
                          </td>
                          <td>
                            <p>NPK</p>
                          </td>
                          <td>
                            <p>Natrossol,&nbsp;</p>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>
                            <p>Hydrated Lime</p>
                          </td>
                          <td>
                            <p>Guar Gum</p>
                          </td>
                          <td>
                            <p>PVC Resin</p>
                          </td>
                          <td>
                            <p>Sodium Carboxy Methyl Celllulose (CMC)</p>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>
                            <p>Tri-Ethylene Glycol</p>
                          </td>
                          <td>
                            <p>Corn Strach</p>
                          </td>
                          <td>
                            <p>Ferrous Aluminum Sulfate</p>
                          </td>
                          <td>
                            <p>MSG</p>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <p></p>
                  <p>
                    <img
                      alt="Product Samples"
                      height={250}
                      src="assets/images/products/agronew.png"
                      width={557}
                    />
                  </p>
                  <p>
                    We supply different types of Chemicals products to various
                    companies and industries. The industries that we serve are
                    grouped into 3 Divisions: Petroleum/Petrochemicals, Paint
                    and Coatings, Food and Pharmaceuticals we have efficient and
                    professional team well organized company. Our Team of Fully
                    Qualified Chemists & DGSAs Can Advise on Chemical Safety &
                    Compliance and Offer Support & Advice on The Handling &
                    Subsequent Disposal of Laboratory Chemicals
                  </p>
                  
                </div>
              </div>
              {/* /.text-block */}
            </div>
            {/* /.col-lg-8 */}
            <div className="col-sm-12 col-md-12 col-lg-2" />
          </div>
          {/* /.row */}
        </div>
        {/* /.container */}
      </section>
    </div>
  );
};

export default ChemicalProducts;
